import type { SVGProps } from 'react';
const SvgMuseum = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#museum_svg__a)">
      <path
        fill="currentColor"
        d="M22 11V9L12 2 2 9v2h2v9H2v2h20v-2h-2v-9h2Zm-6 7h-2v-4l-2 3-2-3v4H8v-7h2l2 3 2-3h2v7Z"
      />
    </g>
    <defs>
      <clipPath id="museum_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgMuseum;
